import pickBy from 'lodash/pickBy';
import { Component } from 'react';
import { getUltLogByLocalStorage } from '../../../../../common/ult/SummarizeUserAction';

// CustomLogger移行後
interface IProps {
  // CustomLogger移行完了後にpageDataへ命名変更予定
  pageParam: {
    title?: string;
    service: string;
    pagetype: string;
    conttype?: string;
    opttype: string;
    apptype: string;
    srcname?: string;
    cat_path?: string;
    ctsid?: string;
    topittl?: string;
    topitime?: string;
    topiname?: string;
    mid?: string;
    mit_serv?: string;
    ispicked?: string;
    shcid?: string;
    rcnsid?: string;
    vtestid?: string;
    vtgrpid?: string;
    status?: string;
    v_pkjp?: number;
    autoplay?: string;
    body_cnt?: number;
    payment?: string;
    mtestid: string;
    par_cnt?: number;
    rel_cnt?: number;
    rel_type?: string;
    acttype?: string;
    query?: string;
    ins?: string;
    rs?: number;
    hasvideo?: '0' | '1'; // 0の場合が通常記事,1の場合が動画付き記事
    is_bfche?: '0' | '1'; // 0の場合bfcache無効、1の場合bfcache有効
    ht_ref?: string;
    expick?: '0' | '1';
  };
  isEnabledViewable: boolean;
  // SPA対応時などに任意のタイミングでインスタンス更新が必要な場合にこの値を更新する
  // SPA対応を行う際は以下のisManualUpdateもtrueにする
  spaPvCount?: number;
  isManualUpdate: boolean;
}

export default class CustomLoggerComponent extends Component<IProps> {
  private customLogger: CustomLogger | undefined;
  /**
   *
   */
  public componentDidMount() {
    const abTestBuckets: { [experimentId: string]: string } = {};
    this.props.pageParam.mtestid.split('&').forEach(item => {
      const [experimentId, bucketId] = item.split('=');
      if (experimentId && bucketId) {
        abTestBuckets[experimentId] = bucketId;
      }
    });

    if (!this.validatePageData() || !window.DSCustomLogger) {
      return;
    }
    this.customLogger = new window.DSCustomLogger.CustomLogger();

    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        this.createCustomLoggerInstance({
          isBFCache: true,
          isPrerendered: false
        });
      }
    });

    if (document.prerendering) {
      document.addEventListener(
        'prerenderingchange',
        () => this.createCustomLoggerInstance({ isBFCache: false, isPrerendered: true }),
        {
          once: true
        }
      );
      return;
    }
    this.createCustomLoggerInstance({ isBFCache: false, isPrerendered: false });
  }

  // 手動更新の場合はspaPvCountの値が変更されたら、CustomLoggerインスタンスを再生成する
  // Spa用のPVカウントの値が0の場合があるのでundefinedチェックしている。
  /**
   * @param nextProps
   */
  public shouldComponentUpdate(nextProps: IProps) {
    return (
      this.props.isManualUpdate && nextProps.spaPvCount !== undefined && this.props.spaPvCount !== nextProps.spaPvCount
    );
  }
  /**
   *
   */
  public componentDidUpdate() {
    this.createCustomLoggerInstance({ isBFCache: false, isPrerendered: false });
  }
  /**
   * アンマウント時は設定を破棄する
   */
  public componentWillUnmount() {
    if (!this.customLogger) {
      return;
    }
    this.customLogger.destroy();
  }
  /**
   *
   */
  public render() {
    return null;
  }
  private createCustomLoggerInstance = ({
    isBFCache,
    isPrerendered
  }: {
    isBFCache: boolean;
    isPrerendered: boolean;
  }) => {
    if (!this.customLogger) {
      return;
    }
    const pageDataFromLocalStorage = getUltLogByLocalStorage(this.props.pageParam);
    const params = {
      // ローカルストレージから取得した情報は明示的にマッピングする
      visit: pageDataFromLocalStorage.pageViewDaysInLast7days,
      cmt_view: pageDataFromLocalStorage.newestCommentViewTime,
      cmt_hide: pageDataFromLocalStorage.userCommentDisplaySetting,
      // 値が0(falsy)の場合取り除かれるので文字列に置き換える
      cmt_vote: String(pageDataFromLocalStorage.userCommentVoteCount),
      cmt_post: String(pageDataFromLocalStorage.userCommentPostCount),
      is_bfche: isBFCache ? '1' : '0',
      is_prere: isPrerendered ? '1' : '0'
    };
    this.customLogger.destroy();
    this.customLogger
      .targetClass('tracked_mods')
      // undefinedの値のものはパラメーターから明示的に取り除く
      // @see https://wiki.workers-hub.com/pages/viewpage.action?pageId=1454288993
      .setPageData(
        pickBy(
          Object.assign({}, this.props.pageParam, params),
          (val): val is string | number => typeof val !== 'undefined'
        )
      );

    this.customLogger.setCustomLoggerCoreConf({
      click_sendbeacon: true,
      viewability: this.props.isEnabledViewable,
      target_modules_viewability: [],
      viewability_time: 1000
    });

    window.customLogger = this.customLogger.initCustomLoggerCore();
  };
  private validatePageData(): boolean {
    const pageData = this.props.pageParam;
    return pageData.service !== '' && pageData.pagetype !== '' && pageData.opttype !== '' && pageData.apptype !== '';
  }
}
